<template>
  <div>
    <v-card class="card-shadow">
      <div class="card-header-padding card-border-bottom" v-if="!initialloading">
        <v-row class="d-flex justify-space-between py-5 px-5 lista-header">
          <div>
            <p class="font-weight-600 text-h3 text-typo mb-1">
              Lista de Promotores
            </p>
            <p class="text-body font-weight-thin text-body-2 ls-0 mb-0">
              Segue abaixo a listagem de todos os promotores disponíveis
            </p>
          </div>
          <v-btn
            elevation="0"
            :ripple="false"
            height="43"
            @click="link('/register/promoter')"
            class="
              font-weight-600
              text-capitalize
              btn-primary
              py-3
              px-6
              rounded-sm
            "
            color="#0f88f2"
            v-if="habiliarCriarPromotor"
            >Novo Promotor</v-btn
          >
        </v-row>
                <!-- <Dropdown
              label="hotel"
              placeholder="Selecione um hotel"
              :options="hoteis"
              v-model="hotel"
              id="hotel"
              :sideEffect="alteracaocampohoteis"
              data-cy="hotel"
              :border="'2px solid rgba(15, 136, 242, 0.3)'"
              :borderactive="'2px solid rgba(15, 136, 242)'"
              :borderradius="'0.7125rem'"
              :icon="'ni ni-building'"
              :ableToSearch="true"
              :reset="hotelreset"
              :initialValue="hotel"
            /> -->
      </div>
      <div class="card-header-padding card-border-bottom" v-if="!initialloading">
        <span class="search-wrapper">
          <span class="search-field">
            
          <unicon fill="#0f88f2" name="search" />
          
          <input 
            type="text"
            v-model="nomepesquisa"
            class="search-input"
            :placeholder="'Faça sua busca'"
          />
          </span>
          <span>
          <button type="button" class="search-button" @click="buscaPromotor">Pesquisar</button>
          <button type="button" class="reset-button" @click="resetaPromotor">Resetar</button>
          </span>
        </span>
      </div>

      <v-card-text class="px-0 py-0" v-if="!initialloading">
        <v-data-table
          :headers="headers"
          :items="items"
          :page.sync="page"
          hide-default-footer
          @page-count="pageCount = $event"
          :items-per-page="itemsPerPage"
          mobile-breakpoint=480
          @click:row="(item) => link(`/list/promoter/${item.idusuario}`)"
          data-cy="tabela-lista-promotor"
        >

          <template v-slot:item.idusuario="{ item }">
            <span class="text-body text-h5">
              {{ item.idusuario }}
            </span>
          </template>

          <template v-slot:item.nome="{ item }">
            <span class="text-body text-h5">
              {{ item.nome }}
            </span>
          </template>

          <template v-slot:item.numerodocumento="{ item }">
            <span class="text-body text-h5">
              {{ item.numerodocumento }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              @click="editItem(item)"
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="
                font-weight-600
                text-capitalize
                btn-ls btn-warning
                me-2
                my-2
                rounded-sm
              "
              color="#fb6340"
            >
              <v-icon size="12">ni-ruler-pencil</v-icon>
            </v-btn>

            <v-btn
              @click="deleteItem(item)"
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="
                font-weight-600
                text-capitalize
                btn-ls btn-danger
                me-2
                my-2
                rounded-sm
              "
              color="#f5365c"
            >
              <v-icon size="12">ni-fat-remove</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="card-padding" v-if="!initialloading">
        <v-row>
          <v-col cols="6" lg="5" class="d-flex align-center">
            <span class="text-body me-3">Items per page:</span>
            <v-text-field
              hide-details
              type="number"
              outlined
              min="-1"
              max="15"
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              :value="itemsPerPage"
              @input="itemsPerPage = parseInt($event, 10)"
              placeholder="Items per page"
              class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" lg="5" class="d-flex align-center">
            <v-btn
              elevation="2"
              outlined
              small
              text
              @click="exportar"
              v-if="items.length"
              >
              exportar excel
            </v-btn>
          </v-col>
          <v-col cols="6" class="ml-auto d-flex justify-end">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#0f88f2"
              v-model="page"
              :length="pageCount"
              circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <ListSkeleton v-if="initialloading"/>
  </div>
</template>
<script>
import PromotorServico from "../../../servicos/promotor.servico";
import ListSkeleton from '../../../components/Loading/ListSkeleton.vue'
import Dropdown from '../../../components/Dropdown.vue'
import {exportToExcel} from '../../../util/excel.js'
export default {
  name: "paginated-tables",
  components: {ListSkeleton, Dropdown},
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: "Id", value: "idusuario" },
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "numerodocumento" },
        { text: "Hotel", value: "nomehotel" },
      ],
      items: null,
      nomepesquisa: null,
      hotel: null,
      hoteis: [],
      idusuario: null,
      idusuariotipo: null,
      initialloading:false,
      habiliarCriarPromotor: false,
    };
  },
  watch: {
    page() {
      this.buscaPromotor();
    },
  },
  methods: {
    exportar(){
      let data = this.items
      exportToExcel(data, 'planilha-dados-promotores')
    },

    link(to) {
      this.$router.push(to);
    },

    async buscaPromotor(){
      let query;
      if(this.idusuariotipo === 2){
        query = {
          nome: this.nomepesquisa, 
          idusuariotipo: 5, 
          idadmhotel: this.idusuario,
          page:this.page
        }
      }else if(this.idusuariotipo === 1){
         query = {
          nome: this.nomepesquisa, 
          idusuariotipo: 5, 
          page:this.page
        }
      }
      const {data} = await PromotorServico.buscar(query)
      this.items = data
    },
    async resetaPromotor(){
       await this.requisitarPromotores()
       this.nomepesquisa = null
    },
    async requisitarPromotores(){
      if(this.idusuariotipo === 2){
        const idadmhotel = this.idusuario
        const {data} = await PromotorServico.listarPorAdmHotel(idadmhotel,{page:this.page})
        PromotorServico.listarPorAdmHotelQtde({idadmhotel:idadmhotel,page:this.page}).then(resp =>{
          this.pageCount = Math.ceil(resp.data[0].qtde/10)
        });
        
        // for(let j = 0; j<data.length;j++){
        //   try{
        //     let item = data[j]
        //     const response = await PromotorServico.nomeHotel(item.idusuario)
        //     data[j].nomehotel = response.data
        //   }catch(e){
        //     console.log('error nome hotel', error)
        //   }
        // }
        this.items = data
      }else if(this.idusuariotipo===1){
        const {data} = await PromotorServico.listarTodos({page:this.page})
        PromotorServico.listarTodosQtde({page:this.page}).then(resp =>{
          this.pageCount = Math.ceil(resp.data[0].qtde/10)
        });
        // for(let j = 0; j<data.length;j++){
        //   try{
        //     let item = data[j]
        //     const response = await PromotorServico.nomeHotel(item.idusuario)
        //     data[j].nomehotel = response.data
        //   }catch(e){
        //     console.log('error nome hotel', e)
        //   }
        // }
        this.items = data
      }
    }

  },

  async mounted() {
    this.initialloading = true
    //alterar viualizacao dos botoes
    const idusuariotipo = parseInt(localStorage.getItem('idusuariotipo'))
    this.idusuario = parseInt(localStorage.getItem('idusuario'))
    this.idusuariotipo = idusuariotipo
    if(this.idusuariotipo === 1){
      this.habiliarCriarPromotor = false
    }else if(this.idusuariotipo === 2){
      this.habiliarCriarPromotor = true
    }
    await this.requisitarPromotores()
    this.initialloading = false
  },
};
</script>
<style lang="scss" scoped>
.search-wrapper{
  display: flex;
  box-shadow: 0 2px 5px rgba(133, 133, 133, 0.4);
  padding: 0.5em 1em;
  border-radius: 0.7125em;
  height: 4em;
  display: flex;
  justify-content: space-between;

}

.search-field{
  .unicon{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.5em;  }
  display: flex;
  align-items: center;
}
.search-input{
  outline: none;
  font-size: 14px;
  color:rgba(0,0,0,0.8);
  flex: 1;  
}

.search-button{
  border: 2px solid #0f88f2;
  box-shadow: 0 2px 5px rgba(133, 133, 133, 0.4);
  border-radius: 0.7125em;
  color: white;
  font-weight: bold;
  font-size: 14px;
  padding: .5em 1em;margin-right: .5em;
  color: #0f88f2;
}
.reset-button{
    border: 2px solid rgba(133, 133, 133, 0.4);
  box-shadow: 0 2px 5px rgba(133, 133, 133, 0.4);
  border-radius: 0.7125em;
  color: white;
  font-weight: bold;
  font-size: 14px;
  padding: .5em 1em;
  color: rgba(133, 133, 133, 0.4);
}
.lista-header{
  @media screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;

    > button {
      margin-top: 1.5em;
    }    
  }
}

::v-deep tbody tr {
  cursor: pointer;
}
.v-data-table {
  width: 100%;
  text-align: left;
}
</style>
